<template>
  <div class="package-list-item">
    <img :src="imageUrl" class="image" />
    <div class="meta">
      <router-link :to="route" class="name">{{ name }}</router-link>
      <p class="desc">{{ desc }}</p>
      <p class="desc">
        <span v-if="originalPrice" class="original-price">{{
          originalPriceText
        }}</span>
        {{ priceText }}
      </p>
    </div>
  </div>
</template>

<script>
import {
  convertBathToStangAndRoundTwoDecimal,
  formatCurrencyAndTwoDecimalsString,
} from "@/lib/formatter"

export default {
  props: {
    value: {
      type: null,
      default: undefined,
    },
  },
  computed: {
    desc() {
      return `${this.target} — ${this.detail}`
    },
    originalPriceText() {
      if (!this.originalPrice) {
        return ""
      }

      return `${formatCurrencyAndTwoDecimalsString(
        convertBathToStangAndRoundTwoDecimal(this.originalPrice),
      )} บาท`
    },
    priceText() {
      const baht = formatCurrencyAndTwoDecimalsString(
        convertBathToStangAndRoundTwoDecimal(this.price),
      )
      const isMonthly = this.billingCycle === 1
      const months = isMonthly ? "" : `${this.billingCycle} `

      return `${baht} บาท / ${months}เดือน`
    },
    imageUrl() {
      return this.value.imageUrl
    },
    name() {
      return this.value.name
    },
    route() {
      return this.value.route
    },
    target() {
      return this.value.target
    },
    detail() {
      return this.value.detail
    },
    originalPrice() {
      return this.value.originalPrice
    },
    price() {
      return this.value.price
    },
    billingCycle() {
      return this.value.billingCycle
    },
    type() {
      return this.value.type
    },
  },
}
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";
$logoSize: 120px;

.package-list-item {
  width: 100%;
  display: flex;
  flex-flow: row nowrap;

  align-items: center;

  border-bottom: $border;
  padding: ($space / 2) $space;

  > .image {
    display: block;

    border-radius: 8px;
    width: $logoSize;
    height: 90px;
    flex: 0 0 $logoSize;
  }

  > .meta {
    padding-left: $space;
    display: block;

    flex-grow: 1;
  }
}

.meta {
  margin-top: -4px;
  min-width: 0;

  > .name {
    display: inline-block;
    font-size: 1rem;

    &:hover {
      color: black;
    }
  }

  > .desc {
    overflow: hidden;
    height: 23px;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

.meta p {
  line-height: 1.6;
  font-size: 0.9rem;
  color: #777;
}

.provider {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;

  > .logo {
    margin-right: 12px;

    border-radius: $border-radius;
    width: 24px;
    height: 24px;
  }
}

.original-price {
  text-decoration: line-through;
}
</style>
